import React, { useState } from 'react';
import { services } from '../data/mock';

const ServicesSection = () => {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <section id="services" style={{
      backgroundColor: '#000',
      padding: '0 0 120px 0',
      borderTop: '1px solid rgba(255,255,255,0.06)',
    }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '80px 40px 0' }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '60px' }}>
          <div>
            <span style={{
              color: '#C8102E',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '12px',
              fontWeight: '700',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '16px',
            }}>Core Focus Areas</span>
            <h2 style={{
              color: '#ffffff',
              fontFamily: "'Climate Crisis', sans-serif",
              fontSize: 'clamp(28px, 4vw, 48px)',
              fontWeight: '400',
              letterSpacing: '0em',
              lineHeight: '1.1',
              margin: 0,
            }}>
              Where I Create Impact
            </h2>
          </div>
        </div>

        {/* Services Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '12px',
        }} className="services-grid">
          {services.map((service) => (
            <div
              key={service.id}
              onMouseEnter={() => setHoveredId(service.id)}
              onMouseLeave={() => setHoveredId(null)}
              style={{
                position: 'relative',
                backgroundColor: '#0d0d0d',
                padding: '0',
                overflow: 'hidden',
                cursor: 'default',
                borderRadius: '20px',
                border: '1px solid rgba(255,255,255,0.06)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                transform: hoveredId === service.id ? 'translateY(-4px)' : 'translateY(0)',
                boxShadow: hoveredId === service.id ? '0 20px 50px rgba(0,0,0,0.4)' : 'none',
              }}
            >
              {/* Image with overlay */}
              <div style={{ position: 'relative', height: '260px', overflow: 'hidden', borderRadius: '20px 20px 0 0' }}>
                <img
                  src={service.image}
                  alt={service.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    filter: 'brightness(0.45) grayscale(0.2)',
                    transition: 'transform 0.5s ease, filter 0.3s ease',
                    transform: hoveredId === service.id ? 'scale(1.04)' : 'scale(1)',
                  }}
                />
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to bottom, transparent 40%, rgba(0,0,0,0.8) 100%)',
                }} />
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  left: '24px',
                  background: service.id % 2 === 0 ? 'rgba(27,61,42,0.9)' : 'rgba(200,16,46,0.9)',
                  backdropFilter: 'blur(8px)',
                  borderRadius: '100px',
                  padding: '5px 14px',
                  border: `1px solid ${service.id % 2 === 0 ? 'rgba(27,61,42,0.5)' : 'rgba(200,16,46,0.5)'}`,
                }}>
                  <span style={{
                    color: '#ffffff',
                    fontFamily: "'Figtree', sans-serif",
                    fontSize: '11px',
                    fontWeight: '700',
                    letterSpacing: '0.12em',
                    textTransform: 'uppercase',
                  }}>
                    {service.category}
                  </span>
                </div>
              </div>

              {/* Text Content */}
              <div style={{ padding: '28px 32px 36px' }}>
                <h3 style={{
                  color: '#ffffff',
                  fontFamily: "'Climate Crisis', sans-serif",
                  fontSize: '22px',
                  fontWeight: '400',
                  letterSpacing: '0em',
                  marginBottom: '12px',
                  lineHeight: '1.3',
                }}>
                  {service.title}
                </h3>
                <p style={{
                  color: 'rgba(255,255,255,0.6)',
                  fontFamily: "'Figtree', sans-serif",
                  fontSize: '14px',
                  fontWeight: '400',
                  lineHeight: '1.7',
                  marginBottom: '20px',
                }}>
                  {service.description}
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {service.tags.map((tag, i) => (
                    <span key={i} style={{
                      color: '#ffffff',
                      fontFamily: "'Figtree', sans-serif",
                      fontSize: '11px',
                      fontWeight: '600',
                      letterSpacing: '0.08em',
                      textTransform: 'uppercase',
                      backgroundColor: i === 0 ? 'rgba(200,16,46,0.15)' : 'rgba(27,61,42,0.2)',
                      border: `1px solid ${i === 0 ? 'rgba(200,16,46,0.4)' : 'rgba(27,61,42,0.5)'}`,
                      borderRadius: '20px',
                      padding: '4px 10px',
                    }}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .services-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesSection;
